<!-- MarkTeacherModal：设置教师组件 2024/03/07 13:38:09 XiJiGuo -->

<template>
  <!-- 设置教师弹窗 -->
  <yue-dialog :title="'设置' + title" width="1150px" custom-class="mark-teacher-dialog" top="10vh" append-to-body :visible.sync="visible" @open="handleOpen">
    <yue-read-teacher ref="readTeacher" :is-show-school="isRegion" :is-mark-setting="isMarkSetting" :is-show-teacher-manage="isShowTeacherManage" :scene="scene" :key="Date.now()">
      <template #header-right v-if="isShowTeacherManage">
        <el-button type="text" style="font-weight: normal" @click="$router.push('/region/exam/single/teacher-manage/' + task.examId)">教师信息管理</el-button>
      </template>
    </yue-read-teacher>
    <div slot="footer" class="btn-group">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" :loading="submitLoading" @click="submit">确 定</el-button>
    </div>
  </yue-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { baseApi, gradingApi } from '@/v2/utils/api'
import util from '@/utils/util'

export default {
  name: 'mark-teacher',
  props: {
    title: {
      type: String,
      default: '教师'
    },
    scene: {
      type: String,
      // teacher-task:教师维度的试题任务，设置批阅教师
      // school-task:学校维度的试题任务，设置批阅教师
      // create-exam:创建考试任务，设置组长
      default: 'create-exam'
    },
    // 是否批阅设置
    isMarkSetting: {
      type: Boolean,
      default: false
    },
    isRegion: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
       userInfo: 'getUserInfo'
    }),
    isShowTeacherManage () {
      return this.scene != 'create-exam' && this.isRegion
    }
  },
  data () {
    return {
      task: {},
      submitLoading: false,
      visible: false,
      teacherGradingList: []
    }
  },

  methods: {
    async open (task) {
      // task内 markType 字段：1、单评 2、双评
      this.task = JSON.parse(JSON.stringify(task))
      if (this.isMarkSetting) {
        const res = await gradingApi.getTeacherGradingInfo({ examId: this.task.examId })
        try {
          const list = []
          if (res.success) {
            list.push(...res.body)
          } else {
            this.$message.warning(res.$message)
          }
          this.teacherGradingList = list
        } catch (error) {
          this.teacherGradingList = []
          console.error(error)
        }
      }
      this.visible = true
    },
    handleOpen () {
      this.$nextTick(() => {
        if (this.$refs.readTeacher) {
          this.$refs.readTeacher.loadDefault()
        }
      })
    },
    // 获取初始化参数
    defaultYueReadTeacher () {
      return this.task
    },

    // 获取学校信息
    async schoolsYueReadTeacher () {
      const schoolList = this.task.schoolList
      if (schoolList && schoolList.length > 0 && !schoolList.find(s => s.schoolId == this.userInfo.schoolId)) {
        schoolList.unshift({ schoolId: this.userInfo.schoolId, schoolName: this.userInfo.schoolName })
      }

      return { body: schoolList }
    },

    // 获取年级数据
    async gradesYueReadTeacher (schoolId) {
      const res = await baseApi.getGrades(schoolId)
      const gradeList = [{ gradeNum: '', gradeName: '全部' }]
      if (res.body) {
        res.body.forEach(item => {
          gradeList.push({ gradeNum: item.gradeNum + '', gradeName: item.gradeName })
        })
      }
      return gradeList
    },

    // 获取科目信息
    async subjectsYueReadTeacher (item) {
      const subjectList = []
      const response = await baseApi.getGradeSubjects({
        grade: item.gradeNum,
        schoolId: item.schoolId
      })
      if (response.success) {
        response.body.forEach(subject => {
          subjectList.push({ id: subject.subjectId + '', name: subject.subjectName })
        })
      } else {
        this.$message.error(`操作失败, ${response.msg} !`)
      }
      return subjectList
    },

    // 获取教师信息
    async teachersYueReadTeacher (obj) {
      const params = {
        schoolId: obj.form.schoolId,
        gradeNum: obj.form.gradeNum || '',
        subjectCode: obj.form.subjectId || '',
        exactMatch: obj.form.exactMatch,
        pageSize: obj.page.size,
        currentPage: obj.page.current,
        classId: '',
        useStatus: 1
      }
      if (this.isRegion) {
        params.regionId = this.userInfo.schoolId
      }

      // 参数验证,防止参数为undefined 接口报错
      if (params.gradeNum === 'undefined') {
        params.gradeNum = ''
      }
      if (params.subjectCode === 'undefined') {
        params.subjectCode = ''
      }

      // 检测是否是关键词或者手机号
      if (!util.isEmpty(obj.form.keyword)) {
        if (/^1[3-9]\d{9}$/.test(obj.form.keyword)) {
          params.tel = obj.form.keyword
        } else {
          params.nickName = obj.form.keyword.trim()
        }
      }

      // 批阅设置增加分工参数
      if (this.isMarkSetting) {
        const teacherIds = this.teacherGradingList.map(s => s.teacherId)
        if (obj.form.divideState === 1) {
          // 已分工
          params.includeTeacherIds = teacherIds
        } else if (obj.form.divideState === 2) {
          // 未分工
          params.excludeTeacherIds = teacherIds
        }
      }

      const res = await baseApi.queryTeachers(params)
      let list = []
      if (res.body.totalSize > 0) {
        list = this.convertTeacherList(res.body.items)
      }

      return {
        list,
        total: res.body.totalSize
      }
    },

    // 转换教师集合
    convertTeacherList (items) {
      const list = []
      for (let index = 0; index < items.length; index++) {
        const element = items[index]
        const item = {
          schoolName: element.schoolName,
          teacherId: element.teacherId,
          teacherName: element.teacherName,
          tel: element.tel,
          todoGradingNum: 0,
          roleNames: [],
          subjectName: '',
          stateDesc: '待分工'
        }

        if (element.teacherRoleVos && element.teacherRoleVos.length > 0) {
          const subjects = element.teacherRoleVos.filter(item => !util.isEmpty(item.subjectName))
          if (subjects.length > 0) {
            const map = new Map()
            subjects.forEach(item => map.set(item.subjectName, true))
            item.subjectName = Array.from(map.keys()).join(',')
          }
          for (let rIndex = 0; rIndex < element.teacherRoleVos.length; rIndex++) {
            const role = element.teacherRoleVos[rIndex]
            if (role.schoolRoleVo) {
              const name = role.schoolRoleVo.roleName
              if (item.roleNames.includes(name)) continue
              item.roleNames.push(role.schoolRoleVo.roleName)
            }
          }
        }

        if (this.teacherGradingList.length > 0) {
          const grading = this.teacherGradingList.find(s => s.teacherId == item.teacherId)
          if (grading && grading.questionNumbers.length > 0) {
            const questionNums = []
            grading.questionNumbers.forEach(item => {
              questionNums.push(util.standardQuestionNumber(item))
            })
            item.stateDesc = questionNums.join(',')
          }
        }

        if (element.teacherStateVo) {
          item.stateDesc = element.teacherStateVo.stateDesc
        }

        if (element.todoGradingNum > 0) {
          item.todoGradingNum = element.todoGradingNum
        }

        list.push(item)
      }
      return list
    },

    // 保存
    async submit () {
      const list = this.$refs.readTeacher.result()
      if (list.length === 0) {
        return this.$message.error('请选择批阅教师')
      }
      if (this.task.markType === 2 && list.length < 2) {
        return this.$message.warning('双评批阅教师不能少于两人')
      }

      this.$emit('confirm', list, this.task.teacherType)
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.mark-teacher-dialog {
  max-width: 1150px !important;
}
</style>

<style scoped>
.marking-teacher {
  cursor: pointer;
}

.marking-teacher:hover {
  text-decoration: underline;
}
</style>
